export const listVariants = Object.freeze({
  AVAILABLE: "available",
  PROSPECTS: "prospects",
  SOLD: "sold",
});
